module.exports = __webpack_public_path__ + "static/the-little-book-of-common-sense-investing-6b477e98f692b162668ce64b061eef99.jpg";